import type { ThemeLayoutSources } from "@lumora/core";
import { createSiteVariant, packageShowsOwnerNav as tierShowsOwnerNav, TEMPLATE_OWNER_NAV } from "@lumora/ui";

/** Theme aliases: classic ≈ warm-craft, minimal ≈ neutral light, atelier ≈ editorial, harbor = cool teal, terra = clay, sage = botanical. */
export type ThemeName = "classic" | "minimal" | "atelier" | "harbor" | "terra" | "sage";
export type LayoutName = "standard" | "compact" | "editorial" | "story";

const variant = createSiteVariant<ThemeName, LayoutName>({
  themes: ["classic", "minimal", "atelier", "harbor", "terra", "sage"],
  layouts: ["standard", "compact", "editorial", "story"],
  defaultTheme: "minimal",
  defaultLayout: "standard",
});

export const { THEMES, LAYOUTS, DEFAULT_THEME, DEFAULT_LAYOUT, resolveVariant } = variant;

export interface Variant {
  theme: ThemeName;
  layout: LayoutName;
}

export type VariantSources = ThemeLayoutSources;

/** True when package tier includes owner/staff sign-in surfaces. */
export function packageShowsOwnerNav(pkg = import.meta.env.VITE_SITE_PACKAGE): boolean {
  return tierShowsOwnerNav(TEMPLATE_OWNER_NAV, pkg);
}
